import {Component, OnInit} from '@angular/core';
import {Team} from '@api/models/team/team';
import {MatchService} from '../../services/match/match.service';
import {UrlService} from '@utils/services/url/url.service';
import {Event} from '@api/models/event/event';
import {LiveReporterStatus} from '@api/models/event/event-team';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {EnvironmentService} from '@utils/services/environment/environment.service';
import {GetAppDialogComponent} from '@shared/modules/shared-dialogs/dialogs/get-app-dialog/get-app-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'lib-match-reporter-banner',
  templateUrl: './match-reporter-banner.component.html',
  styleUrls: ['./match-reporter-banner.component.scss']
})
export class MatchReporterBannerComponent implements OnInit {

  public team: Team;
  public matchLink: string;
  private match: Event;

  constructor(private matchService: MatchService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.match = this.matchService.match;
    this.team = this.matchService.selectedTeam;
    this.matchLink = UrlService.getMatchUrl(this.match._id, this.team._id);
  }

  public isHidden(): boolean {
    const liveReporterStatus = this.matchService.selectedTeam?.fan_moderator?.status;
    if (liveReporterStatus && liveReporterStatus !== LiveReporterStatus.OPEN &&
      liveReporterStatus !== LiveReporterStatus.IMMEDIATELY) {
      return true;
    }
    if (this.match.hasReporter) {
      return true;
    }
    if (this.match.sportradar?.sr_created || this.match.foes?.foes_created) {
      return !this.match.isPreGame();
    }
    return this.match.isPostGameOrCancelled();
  }

  public onClick() {
    if (EnvironmentService.isWidget) {
      window.open(this.matchLink, '_blank');
    } else {
      this.dialog.open(GetAppDialogComponent, GetAppDialogComponent.getDialogSize());
    }
  }

  public get colorScheme(): ColorScheme {
    return EnvironmentService.isWebsite ? ColorScheme.AltBlue : ColorScheme.Light;
  }
}
